var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupDoneStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1072 20.7733C13.8406 20.7733 13.5872 20.6666 13.4006 20.48L8.29391 15.3733C7.90724 14.9866 7.90724 14.3466 8.29391 13.96C8.68057 13.5733 9.32057 13.5733 9.70724 13.96L14.1072 18.36L22.2939 10.1733C22.6806 9.78663 23.3206 9.78663 23.7072 10.1733C24.0939 10.56 24.0939 11.2 23.7072 11.5866L14.8139 20.48C14.6272 20.6666 14.3739 20.7733 14.1072 20.7733Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupDoneStep);
export default __webpack_public_path__ + "static/media/signup-done-step.44acaa6dd221ac5841c194c2332604bf.svg";
export { ForwardRef as ReactComponent };